<template>
    <section
        class="hero section"
        :class="[
            topOuterDivider && 'has-top-divider',
            bottomOuterDivider && 'has-bottom-divider',
            hasBgColor && 'has-bg-color',
            invertColor && 'invert-color'
        ]">
        <div class="container">
            <div
                class="hero-inner section-inner"
                :class="[
                    topDivider && 'has-top-divider',
                    bottomDivider && 'has-bottom-divider'
                ]">
                <div
                    class="split-wrap"
                    :class="[
                        invertMobile && 'invert-mobile',
                        invertDesktop && 'invert-desktop',
                        alignTop && 'align-top'
                    ]">
                    <div class="split-item">
                        <div class="hero-content split-item-content center-content-mobile">
                            <h1 class="mt-0 mb-16 reveal-from-left">
                                Sending to anywhere.
                            </h1>
                            <p class="mt-0 mb-24 reveal-from-left" data-reveal-delay="200">
                                我们专注于满足国内外客户的运输需求，更快更有效率的将客户的产品送达市场。我们的客户完全可以依赖我们的本地经验与全球网络在供应链的每一环节均能获得超值回报。每周定期航班直送中国，包税清关，借助中国邮政强大的覆盖网络转运，把您的包裹快递到中国的任何地方。
                            </p>
                            <div>
                                <textarea class="form-input"  :placeholder="tip" rows="5" style="resize: none;" v-model="trackingNumbers"></textarea>
                            </div>
                            <div>
                                <div style="float:left;" v-for="(item,index) in historyNumber" :key="item">
                                    <span style="text-decoration:underline;cursor: pointer;color:blue;font-size:15px;" @click="setTrackNo(item)">{{item}}</span>
                                    <span style="cursor: pointer;" @click="deleteTrackNo(index)"> x</span>&nbsp;
                                </div>
                            </div>
                            <div class="reveal-from-left" data-reveal-delay="400" style="clear:both;">
                                <c-button :loading="loading" tag="a" color="primary" wide-mobile href="#" @click='SearchNumber()' style="margin-bottom:50px;">
                                    查询
                                </c-button>
                            </div>
                        </div>
                        <div v-if="screenWidth > 1000" class="hero-figure is-3d split-item-image illustration-element-01 reveal-scale-up">
                            <c-image
                                class="has-shadow"
                                :src="require('@/assets/images/LAND6.jpg')"
                                alt="Hero image"
                                :width="528"
                                :height="396" />
                        </div>
                    </div>
                    <div style="margin-top:-130px;">
                        <h3 v-if="isActive">Not Found</h3>
                        <c-accordion>
                        <c-accordion-item v-for="(item,i) in tracks" :key="item.shipment_id" :title="item" :active='i==0'>
                            <p v-for="(t,index) in item.tracks" :key="index">[{{t.eventDate}}][{{t.eventLocation}}]{{t.eventDescription}}<span style="float:right"></span></p>
                        </c-accordion-item>
                        </c-accordion>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { SectionSplitProps } from '@/utils/SectionProps.js'
import CButton from '@/components/elements/Button.vue'
import CImage from '@/components/elements/Image.vue'
import CAccordion from '@/components/elements/Accordion.vue'
import CAccordionItem from '@/components/elements/AccordionItemForTracks.vue'

export default {
  name: 'CHeroSplit',
  components: {
    CButton,
    CImage,
    CAccordion,
    CAccordionItem
  },
  mixins: [SectionSplitProps],
   data: function() {
    return {
        tip: '货物跟踪\n\n请在此输入您的多条订单号/跟踪号',
        historyNumber: [],
        trackingNumbers: '',
        tracks: [],
        isActive: false,
        loading: false,
        screenWidth: document.body.clientWidth, // 屏幕尺寸
    }},
    mounted() {
        const that = this
        window.onresize = () => {
        return (() => {
          window.screenWidth = document.body.clientWidth
          that.screenWidth = window.screenWidth
        })()
      }
        let historyNumber = localStorage.getItem('historyNumber')
        if(historyNumber === null) {
            localStorage.setItem('historyNumber', JSON.stringify(this.historyNumber))
        }else {
            this.historyNumber = JSON.parse(historyNumber)
        }
  },
    methods: {
        SearchNumber() {
            if(this.trackingNumbers !== ''){
                this.loading = true
                this.tracks = []
                this.$axios.get("https://system.line-1.com/openapi/Logistics/ApiGetTracks",
                {
                    params:{
                        sno: this.trackingNumbers.replace(/[\n\r]/g, ',')
                    }
                }).then((res) => {
                    if(res.data.success){
                        this.tracks = res.data.data
                    }
                }).finally(() => {
                    if(this.tracks.length == 0) {
                        this.isActive = true
                    }else {
                        this.isActive = false
                    }
                    this.loading = false
                });
               
                let arr = this.trackingNumbers.replace(/[\n\r]/g, '\\n').split('\\n')
                let hisArr = JSON.parse(localStorage.getItem('historyNumber'))
                arr.forEach(item => {
                    let filterData = hisArr.filter(value => value == item)
                    if(item !== '' &&  filterData.length === 0) {
                         hisArr.push(item)
                    }
                })
                this.historyNumber = hisArr
                localStorage.setItem('historyNumber', JSON.stringify(hisArr))
            }
        },
        setTrackNo(no) {
            this.trackingNumbers += no + '\n'
        },
        deleteTrackNo(index) {
            this.historyNumber.splice(index, 1) 
            localStorage.setItem('historyNumber', JSON.stringify(this.historyNumber))
        }
    }
}
</script>